import styled from '@emotion/styled'

import { Spacing } from '../../../../enums/spacing'

export const NavNotFoundInfoWrapper = styled.div``

export const NavDefaultInfo = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding-top: ${Spacing.S8};
  padding-bottom: ${Spacing.S8};
`
